import { connect } from 'react-redux';
import BudgetRow from './BudgetRow';
import { sortBudgetRequest, updateBudgetFlag } from '../../../../../store/actions/budgets.actions';

const mapDispatchToProps = { sortBudgetRequest, updateFlag: updateBudgetFlag };

export default connect(null, mapDispatchToProps)(BudgetRow);